import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongsMobileSearchControlAccess.module.scss";
import {useSongsMobileSearchControlAccessLogic} from "./SongsMobileSearchControlAccess.logic";
import {FontIcon} from "../../../../components/common/FontIcon";
import {SongsMobileFilterNav} from "../mobile-filter-nav/SongsMobileFilterNav";

export const SongsMobileSearchControlAccess: VoidFunctionComponent = () => {
  const useSearchClasses = [
    s.titlebarButton,
  ];
  const {
    isMobileSearchActive,
    handleMobileSearchDisplayToggle
  } = useSongsMobileSearchControlAccessLogic();

  if (isMobileSearchActive) {
    useSearchClasses.push(s.searchActive);
  }

  return (
    <div className={s.container}>
      <button className={useSearchClasses.join(` `)} aria-label={"Search"} onClick={handleMobileSearchDisplayToggle}>
        <FontIcon icon={"icon-search"}/>
      </button>
      <SongsMobileFilterNav useClassName={s.titlebarButton} />
    </div>
  );
}
